import { render } from "./TabsSelector.vue?vue&type=template&id=27415f60&scoped=true"
import script from "./TabsSelector.vue?vue&type=script&lang=js"
export * from "./TabsSelector.vue?vue&type=script&lang=js"

import "./TabsSelector.vue?vue&type=style&index=0&id=27415f60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27415f60"],['__file',"src/scripts/sections/common/TabsSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27415f60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27415f60', __exports__)) {
    api.reload('27415f60', __exports__)
  }
  
  module.hot.accept("./TabsSelector.vue?vue&type=template&id=27415f60&scoped=true", () => {
    api.rerender('27415f60', render)
  })

}


export default __exports__